export const APPUSERS_SEARCH = "appUsersSearch";
export const GET_APPUSERS_GET = "getAppUsersGet";
export const APPUSER_GET = "appUserGet"
export const UPDATE_BONUS = "updateBonus";
export const APPUSERS_GET_ALL = "appUsersGetAll";